import React from 'react'

export default function Skeleton ({
  children
}) {
  return (<>{ children }</>)
}